import { normalizeLogo } from '../utils/logoConfig';

const DEFAULT_TEXT_SIZE = 22;

function normalizeTextSize(value) {
  const size = Number(value);
  if (!Number.isFinite(size)) return DEFAULT_TEXT_SIZE;
  return Math.min(40, Math.max(12, Math.round(size)));
}

function normalizeTextStyle(value) {
  return value === 'normal' ? 'normal' : 'italic';
}

export default function Logo({
  mode = 'text',
  text = '',
  textSize = DEFAULT_TEXT_SIZE,
  textStyle = 'italic',
  imageUrl,
  alt = '',
}) {
  const config = normalizeLogo({ mode, text, textSize, textStyle, imageUrl, alt });
  if (!config) return null;

  if (config.mode === 'image' && config.imageUrl) {
    const safeUrl = String(config.imageUrl).replace(/\\/g, '/').replace(/"/g, '');
    return (
      <span
        className="logo__img"
        role="img"
        aria-label={config.alt || ''}
        style={{
          WebkitMaskImage: `url("${safeUrl}")`,
          maskImage: `url("${safeUrl}")`,
        }}
      />
    );
  }

  if (!config.text) return null;

  const size = normalizeTextSize(config.textSize);
  const style = normalizeTextStyle(config.textStyle);

  return (
    <span
      className={`logo__text logo__text--${style}`}
      style={{ '--logo-text-size': `${size}px` }}
      aria-hidden="true"
    >
      {config.text}
    </span>
  );
}
